module.exports = __webpack_public_path__ + "static/dashboard-5782c1ce9d46a57db54b6529519ad2bc.mp4";